module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "book"
  }, [_vm._m(0), _vm._v(" "), _vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "authorInfo"
  }, [_c('h2', {
    staticClass: "authorName heading font1"
  }, [_vm._v("\n      Jon Talton\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "authorDescription body article"
  }, [_c('P', [_vm._v("Jon Talton is a fourth-generation Arizonan, the author of 12 novels, and a former columnist for the Arizona Republic. Talton now lives in Seattle, where he is the economics columnist for the Seattle Times and writes the blog Rogue Columnist.")])], 1)]), _vm._v(" "), _vm._m(2)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "coverInfo"
  }, [_c('img', {
    staticClass: "coverImage",
    attrs: {
      "src": "//textcafe.co/books/iTXEJA/tc-custom/9781615952069.jpg?1731179604530",
      "alt": "This image is the cover for the book Cactus Heart, David Mapstone Mysteries"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "bookInfo"
  }, [_c('h1', {
    staticClass: "bookTitle heading font1"
  }, [_vm._v("Cactus Heart, David Mapstone Mysteries\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "bookDescription body article font2"
  }), _c('p', [_vm._v("In this \"prequel\" to the popular David Mapstone mysteries, author Jon Talton takes us back to 1999, when everything dot-com was making money, the Y2K bug was the greatest danger facing the world, and the good times seemed as if they would never end.")]), _c('p', [_vm._v("It was a time before David and Lindsey were together, before Mike Peralta was sheriff, and before David had rid himself of the sexy and mysterious Gretchen.")]), _c('p', [_vm._v("In Phoenix, it's the sweet season and Christmas and the new millennium are only weeks away. But history professor David Mapstone, just hired by the Sheriff's Office, still finds trouble, chasing a robber into an abandoned warehouse and discovering a gruesome crime from six decades ago.")]), _c('p', [_vm._v("Mapstone begins an investigation into a Depression-era kidnapping that transfixed Arizona and the nation: the disappearance of a cattle baron's grandsons, their bodies never found. And although the kidnapper was caught and executed, Mapstone uncovers evidence that justice was far from done. But this is no history lesson. The cattle baron's heirs now run a Fortune 500 company and wield far more clout than a former-professor-turned-deputy. Then one of the heirs turns up dead....")]), _vm._v(" "), _c('p')])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "publisherInfo"
  }, [_c('h2', {
    staticClass: "publisherName heading font1"
  }, [_vm._v("\n    Poisoned Pen Press\n   ")])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4b7db194","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/home.vue
// module id = 51
// module chunks = 0